export default __webpack_public_path__ + "static/media/logo-us-target.e7c6559b.svg";